import PropTypes from 'prop-types';
import React from 'react';
import connectSensorStateComponent from './DetailPageComponents/SensorStateComponent.jsx';
import { withRouter, Link, Route } from 'react-router-dom';
import { NotificationPage } from './NotificationPage.jsx';

import { ThresholdsPopup } from './DetailPageComponents/ThresholdsPopup.jsx';
import ChartPopup from './DetailPageComponents/ChartPopup.jsx';
import { BackupReportPage } from './ReportingComponents/BackupReport.js';
import axios from "axios";
import { ReportDateProvider } from "./hooks/ReportDateContext";

const NotPage = withRouter(NotificationPage);

var _nonPortMappings = null;
const reVendorLocalhost = new RegExp("http://localhost");
const reVendorLocalhostHttps = new RegExp("https://localhost");
const dateFormatOptions =  { month: "numeric", day: 'numeric', "hour": "numeric", "minute": "numeric", "second": "numeric" };
    
class DetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.basePath = null;
        this.uuid = null;
        this.isSubscribed = false;

        this.handleShowInfo = this.handleShowTab.bind(this, "info");
        this.handleShowConfig = this.handleShowTab.bind(this, "config");
        this.handleShowNotifications = this.handleShowTab.bind(this, "notifications");
        this.handleShowBackup = this.handleShowTab.bind(this, "backups");

        this.openDevice(props.match.params.uuid, props.p);
    }

    state = {
        DriverClass: null,
        driverTpl: null
    };

    static childContextTypes = {
        p: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        basePath: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
        constructTitle: PropTypes.func,
        alerts: PropTypes.array,
        warnings: PropTypes.array
    }

    getChildContext() {
        return {
            basePath: this.basePath,
            uuid:this.uuid,
            constructTitle:this.constructTitle,
            alerts: this.state?.device?.a,
            warnings: this.state?.device?.w,
            t: this.props.t,
            p: this.props.p
        };
    }

    getPortTitle = (dataPath, portNumber) => {
        const { t, p } = this.props;
        if (this.Driver !== null) {
            return this.DriverClass.getPortTitle(dataPath, portNumber, this.basePath, t, p);
        }
        return "";
    }

    constructTitle = (props) => {
        const { t, p } = this.props;
        // TODO: Drop these tables. Instead use the topic name as translation key
        if (_nonPortMappings === null) {
            _nonPortMappings = {
                "PduIntTemperature": t('spbus_details_pdu_measures.pdu_int_temp'),
                "PduIntPeakTemperature": t('spbus_details_pdu_measures.pdu_int_peak'),
                "PduExtTemperature": t('spbus_details_pdu_measures.pdu_ext_temp'),
                "PduExtPeakTemperature": t('spbus_details_pdu_measures.pdu_ext_peak'),
                "ATSAVoltage": t('topic_titles.atsavoltage'),
                "ATSBVoltage": t('topic_titles.atsbvoltage'),
                "ATSAEnergy": t('topic_titles.atsaenergy'),
                "ATSBEnergy": t('topic_titles.atsaenergy')
            };
        }

        let unitText = null;
        const dataPath = props.chartPath ? props.chartPath : props.dataPath;
        if (props.unit) {
            unitText = props.unit;
        } else if (props.unitState && props.unitState.v) {
            if (this.props.unitTranslatePrefix) {
                unitText = t(props.unitTranslatePrefix + "." + props.unitState.v);
            } else {
                unitText = props.unitState.v;
            }
        }
        if (dataPath) {
            let dataLabel = null;
            if (props.labelTranslatePrefix && props.labelDataPath) {
                const currentData = p.getPath(this.basePath + props.labelDataPath);
                if (currentData && currentData.v) {
                    dataLabel = t(props.labelTranslatePrefix + "." + currentData.v);
                }
            }
            const pathParts = dataPath.split("/");
            if (pathParts.length === 4 && pathParts[1] === "port") {
                if (!dataLabel) {
                    dataLabel = t('topic_titles.' + pathParts[3]?.toLowerCase());
                }
                const portName = this.getPortTitle(dataPath, pathParts[2], props.translatePrefix);
                // This is a path with a port, extract the port number and format using the correct string
                if (unitText) {
                    return dataLabel + " " + t("general.for_port_in_unit", {unit:unitText, port_name:portName, port_number:pathParts[2] + 1});
                } else {
                    return dataLabel + " " + t("general.for_port", {port_name:portName, port_number:pathParts[2] + 1});
                }
            } else {
                return _nonPortMappings[pathParts[pathParts.length-1]];
            }
        }
        return "";
    }

    openDevice = (uuid, p) => {
        if (uuid !== this.uuid) {
            // still subscribed but uuid has changed. Unsubscribe.
            if (this.isSubscribed) {
                p.unsubscribePush(this.basePath + "*");
                console.log("unsubscribing", this.basePath + "*");
            }

            if (this.basePath && this.subscription) {
                p.unsubscribeDS(this.updateInDS, this.subscription);
                this.subscription = null;
            }
            this.isSubscribed = false;
        }
        console.log("new uuid", uuid);
        this.uuid = uuid;
        this.basePath = "sensor/" + uuid + "/";
    }

    updateInDS = (value, oldValue, relativePath) => {
        const { t, p } = this.props;
        // console.log("detailupate", relativePath, varName, path);
        // We want the initial update with undefined relativePath and then we'll update this component only when data contained in the
        // FrontPageItem changes.
        if (relativePath === undefined || relativePath === "" || relativePath === "status/frontpage_Max" ||
            relativePath === "status/frontpage_Alarms") {
            // Also we're not interested in "exend" updates
            if (relativePath !== undefined && !value?.v) {
                return;
            }

            const currentDeviceState = p.DS.sensor[this.uuid].state;

            this.setState({"device": p.DS.sensor[this.uuid]});
        }
    }

    closeDevice = () =>  {
        const { t, p } = this.props;

        if (this.basePath && this.isSubscribed) {
            p.unsubscribePush(this.basePath + "*");
            console.log("unsubscribing", this.basePath + "*");
        }
        if (this.basePath && this.subscription) {
            p.unsubscribeDS(this.updateInDS, this.subscription);
            this.subscription = null;
        }
        this.isSubscribed = false;
        this.basePath = this.uuid = null;
        p.removeListener("authenticated", this.onAuthenticated);
    }

    componentDidMount() {
        const { t, p } = this.props;

        if (p.isAuthenticated()) {
            this.onAuthenticated();
        } else {
            p.addListener("authenticated", this.onAuthenticated);
        }
    }

    onAuthenticated = () =>  {
        const self = this;
        const { t, p } = this.props;

        p.subscribePush(this.basePath + "*", true).then(function (success) {
            // Tell the SensorStateComponent to attach to the sensor and connection state
            self.props.setSensorPath(self.basePath);
            // console.log("subscribed", self.basePath + "*");
            self.isSubscribed = true;
            self.updateInDS();
            self.subscription = p.subscribeDS(self.basePath, self.updateInDS);
            let deviceFound = false;

            if (self.uuid && p.DS.sensor && p.DS.sensor[self.uuid]) {
                let device = p.DS.sensor[self.uuid];
                if (device.type && device.tpl && device.state) {

                    self.setState((state) => {
                        // Check if we need load a different driver
                        const stateUpdate = {
                            "device":device,
                            "showConfig": false
                        };

                        const needNewDriver = state.driverTpl !== device.tpl;

                        if (needNewDriver) {
                            (function(tplLoaded) {
                                import(/* webpackChunkName: "[request]" */ './Drivers/' + tplLoaded + '.jsx')
                                    .then(({ default: _ }) => {
                                        // Check if we're still on the template that we loaded
                                        if (tplLoaded === device.tpl) {
                                            // Yep, set it as state
                                            self.setState({
                                                DriverClass: _,
                                                Driver: withRouter(_),
                                                driverTpl: tplLoaded
                                            });
                                        } else {
                                            console.log("Ignoring loaded driver because new tpl is", device.tpl);
                                        }
                                    }).catch((e) => {
                                        console.error("Couldn't load driver class", e);
                                    });
                            })(device.tpl);

                            // Unset current driver
                            stateUpdate.DriverClass = null;
                            stateUpdate.Driver = null;
                        }

                        return stateUpdate;
                    });
                    deviceFound = true;
                }
            }
            if (!deviceFound) {
                this.setState({
                    "error": null,
                    "device": {
                        "type": "",
                        "config": {},
                        "data": {},
                        "status": {},
                        "state": "",
                        "v": null,
                        ts: 0,
                    }, "showConfig": false
                });
            }
        }).catch((err) => {
            if (err === "no_license") {
                self.setState({"error":"no_license"});
                // alert("Your license has expired");
            }
        });
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log("Detail props", nextProps);
    //     var self = this;
    //     if (nextProps.params.uuid && nextProps.params.uuid !== this.uuid) {
    //         this.openDevice(nextProps.params.uuid);
    //         if (p.isAuthenticated()) {
    //             this.onAuthenticated();
    //         } else {
    //             p.addListener("authenticated", this.onAuthenticated);
    //         }
    //     }
    // }

    shouldComponentUpdate(nextProps, nextState) {
        const { t, p } = this.props;
        if (nextProps.match.params.uuid !== this.uuid) {
            this.openDevice(nextProps.match.params.uuid, p);
            if (p.isAuthenticated()) {
                this.onAuthenticated();
            } else {
                p.addListener("authenticated", this.onAuthenticated);
            }
            return true;
        }
        if (nextState.driverTpl !== this.state.driverTpl || nextState.DriverClass !== this.state.DriverClass) {
            return true;
        }

        if (nextProps?.params?.uuid !== this.props?.params?.uuid) {
            return true;
        }

        if (nextProps?.location?.pathname !== this.props?.location?.pathname) {
            return true;
        }

        if (nextState?.device?.ts !== this.state?.device?.ts) {
            return true;
        }
        if (nextState?.error !== this.state?.error) {
            return true;
        }
        if (nextProps?.params?.tab !== this.props?.params?.tab) {
            return true;
        }

        if (nextState?.device?.w !== this.state?.device?.w || nextState?.device?.a !== this.state?.device?.a) {
            return true;
        }
        if (nextState?.showDeleteSure !== this.state?.showDeleteSure || nextState?.deleteError !== this.state?.deleteError) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        console.log("detail unmount");
        this.closeDevice();
        this.Driver = null;
    }

    handleShowTab (tab) {
        this.props.history.replace({
            pathname: "/devices/" + this.props.match.params.uuid + "/" + tab,
            query: this.props.location.query
        });
        // console.log("Path", this.props.router.createHref(this.props.route.path, {tab: tab}));
        // this.setState({ "tab": tab });
    }

    removeDevice = () => {
        const self = this;
        this.setState((state) => {
            if (!state.showDeleteSure) {
                return {
                    showDeleteSure: true,
                    deleteError: undefined,
                };
            }
            axios.get(`/apiv2/deviceMgmt?path=${encodeURIComponent("/sensor/" + this.uuid)}`).then((result) => {
                // Success, navigate to other view
                this.props.history.replace({
                    pathname: "/devices"
                });
            }, (error) => {
                this.setState({deleteError: error})
            })
        })
    }

    render() {
        if (!this.isSubscribed) {
            return null;
        }
        const { t, p } = this.props;
        const self = this;
        var adminUrl = null;

        var unlockDivClasses = "overview__details__item__switch ";
        if (!this.state.showConfig) {
            unlockDivClasses += "is_active";
        } else {
            unlockDivClasses += "is_inactive";
        }

        const createHint = function(translationKey, goalKey, linkRoute) {
            const inputStr = t('details_status.' + translationKey);
            const goalPos = inputStr.indexOf("GOAL");
            if (goalPos === -1) {
                return (
                    <span>
                        {inputStr}
                    </span>
                );
            }
            const partOne = inputStr.substring(0, goalPos);
            return (
                <span>
                    { partOne }
                    <Link to={linkRoute}>{ t('details_status.' + goalKey) }</Link>
                    { inputStr.substr(goalPos + 4)}
                </span>
            );
        };

        let driver;
        let adminIsSafe = false;

        let errorMsg = null, errorHint = null;

        // First, check if a specific error state is already known
        if (this.state.error) {
            errorMsg = t("error." + this.state.error);
            if (this.state.error === "no_license") {
                errorHint = createHint("device_hint_check_license", "device_hint_check_license_goal", "/settings/general");
            }
        } else {
            let connErrState = null;
            // If not, we might have a problem with the connection to the device
            if (this.props.connection && this.props.connection.state !== "RUNNING") {
                connErrState = this.props.connection.state;
            } else {
                // The connection is up and running, but the device itself might have disconnected
                if (this.state.device && this.state.device.state !== "RUNNING") {
                    connErrState = this.state.device.state;
                }
            }

            if (connErrState) {
                errorMsg = t("details_status.device_" + connErrState);
                if (["NOT_AVAILABLE", "CANNOT_CONNECT_TRANSIENT", "CONNECTING"].indexOf(connErrState) !== -1) {
                    errorHint = createHint("device_hint_check_connections_net", "device_hint_check_connections_goal", "/settings/devices");
                } else if (this.state.device.state === "AUTHENTICATION_FAILED") {
                    errorHint = createHint("device_hint_check_connections", "device_hint_check_connections_auth", "/settings/devices");
                } else if (this.state.device.state === "SOURCE_DISCONNECTED") {
                    errorHint = createHint("device_hint_check_links", "device_hint_check_links_goal", "/settings/general");
                } else if (this.state.device.state === "NOT_YET_STARTED" || this.state.device.state === "DELETED") {

                    const errorBox = this.state.deleteError && (
                        <p>
                            <span className="label label-error">{ t("details_status.device_hint_removal_error") }</span>
                        </p>
                    )
                    errorHint = (
                        <div className="detailpage__alert__right">
                            <p>
                                { t("topic_titles_info.SerialNumber") }: { this.state.device?.status?.info?.v?.SerialNumber || 'Unknown' }<br />
                                { t("topic_titles_info.MacAddress") }: { this.state.device?.status?.info?.v?.MacAddress || 'Unknown' }<br />
                                { t("details_status.device_hint_last_seen") }: { Intl.DateTimeFormat(navigator.language, dateFormatOptions).format(this.state.device.ts).replace(/ /g, "\u00a0") }<br />
                            </p>
                            <p>
                                { t("details_status.device_hint_remove_text_1") }<br />
                                { t("details_status.device_hint_remove_text_2") }
                            </p>
                            <p>
                                <button
                                    className={`btn ${this.state.showDeleteSure ? "btn-error" : "btn-primary"}`}
                                    onClick={this.removeDevice}>
                                    { t(`details_status.device_hint_remove_button${this.state.showDeleteSure ? "_sure" : ""}`) }
                                </button>
                            </p>
                            { errorBox }
                        </div>
                    )
                }
            }
            driver = ((
                <div className="detailpage__alert">
                    <div className="detailpage__alert__left">
                        <h2>{t('general.Error')}</h2>
                        <p>{ errorMsg }</p>
                    </div>
                    { errorHint ? (
                        <div className="detailpage__alert__right">
                            <h4>{t('details_status.next_steps')}</h4>
                            {errorHint}
                        </div>
                    ):null}
                </div>

            ));

            /*
                                <div className="overview__footer">
                    Nothing to show here
                </div> */
        }

        if (errorMsg === null) {
            if (!this.state.device.tpl) {
                driver = null;
            } else {
                if (!this.state.DriverClass || !this.state.Driver) {
                    driver = (
                        <div className="wrapper devices">
                            <div className="loading loading-lg"></div>
                        </div>
                    );
                    
                } else {
                    driver = (
                        <this.state.Driver {...this.state.device} showConfig={this.props.match.params.tab === "config"} t={t} p={p} uuid={this.uuid} isSubscribed={this.isSubscribed} />
                    );
                    if (this.state.device.status.VendorAdminUrl) {
                        adminUrl = this.state.device.status.VendorAdminUrl.v;
                        if (reVendorLocalhost.exec(adminUrl)) {
                            adminUrl = adminUrl.replace(reVendorLocalhost, "http://" + window.location.hostname);
                            adminIsSafe = true;
                        } else if (reVendorLocalhostHttps.exec(adminUrl)) {
                            adminUrl = adminUrl.replace(reVendorLocalhostHttps, "https://" + window.location.hostname);
                            adminIsSafe = true;
                        }
                    }

                }
            }
        }

        return (
            <React.Fragment>
                <div className="details-header">
                    <h1>{ this.state?.device?.name || "Loading"}</h1>
                    <Link className="" to="/devices/">&#8592; {t("detail.back_to_overview")}</Link>&nbsp;&nbsp;&#8226;&nbsp;&nbsp;
                    { adminUrl ? (
                        <a href={adminUrl} target="blank" className="">
                            { adminIsSafe ? (
                                <i className="fa fa-lock">&nbsp;</i>
                            ):null
                            }
                            {t('details_configuration.open_vendor_url')}
                        &nbsp;&#8594;</a>
                    ):null
                    }
                </div>

                <ul className="tab tab-block">
                    <li className={(this.props.match.params.tab === "info" || !this.props.match.params.tab) ? "tab-item active" : "tab-item"} onClick={ this.handleShowInfo }>
                        <a href="#">{ t("detail.tab_information") }</a>
                    </li>
                    <li className={this.props.match.params.tab === "config" ? "tab-item active" : "tab-item"} onClick={ this.handleShowConfig }>
                        <a href="#">{ t("detail.tab_configuration") }</a>
                    </li>
                    <li className={this.props.match.params.tab === "notifications" ? "tab-item active" : "tab-item"} onClick={ this.handleShowNotifications }>
                        <a href="#">{ t("detail.tab_notifications") }</a>
                    </li>
                    <li className={this.props.match.params.tab === "backups" ? "tab-item active" : "tab-item"} onClick={ this.handleShowBackup }>
                        <a href="#">{ t("detail.tab_backups") }</a>
                    </li>
                </ul>

                <div className="content classic overview">

                    { this.props.match.params.tab === "notifications" && (
                        <NotPage sensorId={this.uuid} baseUrl={"/devices/" + this.uuid} />
                    )}

                    { this.props.match.params.tab === "backups" && (
                        <ReportDateProvider>
                            <BackupReportPage sensorId={this.uuid} title={t("reporting_backups.title_device", { deviceName: this.state?.device?.name })} t={t} />
                        </ReportDateProvider>
                    )}


                    { (this.props.match.params.tab !== "backups" && this.props.location.pathname.indexOf("/notifications") === -1) && driver }

                    {/* <div className="overview__head cf">
                        <Link className="btn btn-primary" onClick={goBack}><i className="icon icon-back"></i></Link>
                            <div className="columns classic__options">
                                <div className="column col-6">
                                    { adminUrl ? (
                                            <a href={adminUrl} target="blank" className="btn overview__head__vendor">
                                                { adminIsSafe ? (
                                                    <i className="fa fa-lock">&nbsp;</i>
                                                    ):null
                                                }
                                                {t('details_configuration.open_vendor_url')}
                                            </a>
                                        ):null
                                    }
                                </div>
                                <div className="column col-6">
                                    <div className={ unlockDivClasses } onClick={this.handleToggleConfig}>
                                        <div className="btn-group btn-group-block">
                                            <a className="btn one">{t('details_configuration.button_information')}</a>
                                            <a className="btn two">{t('details_configuration.button_configuration')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        <div className="overview__head__switcher">
                            Fast-Switch to&nbsp;
                            <select className="details-fast-switcher">
                            </select>
                        </div>

                    </div>*/}

                </div>


                <Route path="/devices/:uuid/thresholds-:popup_path" component={ThresholdsPopup} />
                <Route path="/devices/:uuid/chart-:popup_path" component={ChartPopup} />
            </React.Fragment>
        );
    }
}

export default connectSensorStateComponent(DetailPage);